import React, { CSSProperties, FC } from 'react';
import { Button, Space } from 'antd';
import { Formik } from 'formik';
import { Form, Input, SubmitButton } from 'formik-antd';
import { FormikOnSubmit } from 'lib/formik.utils';
import { SearchOutlined } from '@ant-design/icons/lib';
import styled from 'styled-components';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { FormattedMessage } from 'react-intl';
import { SubpartnersFilterSelect } from 'common/components/SubpartnersSelect';

const StyledSpace = styled(Space)`
  flex-wrap: wrap;
  > * {
    margin-bottom: 0.5rem;
    flex-grow: 1;
    flex-shrink: 1;
    max-width: 200px;
  }
`;

const StyledForm = styled(Form)`
  max-width: 100%;
`;

export interface ProfileOwnerFiltersFormModel {
  firstName?: string;
  lastName?: string;
  email?: string;
  serialNumber?: string;
  assignedDevice?: boolean;
  partnerID?: number | undefined;
}

export interface ProfileOwnerFiltersProps {
  loading?: boolean;
  value?: ProfileOwnerFiltersFormModel;
  onSubmit: FormikOnSubmit<ProfileOwnerFiltersFormModel>;
  style?: CSSProperties;
  shouldHidePartnerColumn: boolean;
}

export const ProfileOwnersFilters: FC<ProfileOwnerFiltersProps> = ({
  onSubmit,
  loading,
  value = {},
  style,
  shouldHidePartnerColumn,
}) => {
  const intlMessage = useFormatMessage();

  return (
    <Formik initialValues={value} onSubmit={onSubmit} onReset={onSubmit}>
      <StyledForm style={style} layout="inline">
        <StyledSpace>
          <Input
            name="firstName"
            placeholder={intlMessage({ id: 'person.firstName' })}
            style={{ minWidth: 150 }}
          />
          <Input
            name="lastName"
            placeholder={intlMessage({ id: 'person.lastName' })}
            style={{ minWidth: 150 }}
          />
          <Input name="email" placeholder="E-mail" style={{ minWidth: 200 }} />
          {!shouldHidePartnerColumn && (
            <SubpartnersFilterSelect
              name="partnerID"
              placeholder={intlMessage({ id: 'partner' })}
              style={{ minWidth: 200, width: '100%' }}
            />
          )}
          <Space>
            <SubmitButton
              type="default"
              loading={loading}
              icon={<SearchOutlined />}
            >
              <FormattedMessage id="search" tagName="span" />
            </SubmitButton>
            <Button htmlType="reset">
              <FormattedMessage id="clear" />
            </Button>
          </Space>
        </StyledSpace>
      </StyledForm>
    </Formik>
  );
};
